import { render, staticRenderFns } from "./DetailDesignSearch.vue?vue&type=template&id=f721e512&scoped=true&"
import script from "./DetailDesignSearch.vue?vue&type=script&lang=js&"
export * from "./DetailDesignSearch.vue?vue&type=script&lang=js&"
import style0 from "./DetailDesignSearch.vue?vue&type=style&index=0&id=f721e512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f721e512",
  null
  
)

export default component.exports